
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Quelle est le coût de création de site internet en 2026",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "En 2026, la création d'un site internet demeure essentielle pour de nombreuses entreprises et individus. Mais quelle somme devez-vous réellement prévoir pour ce projet ?",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Quelle est le coût de création de site internet en 2026",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "En 2026, la création d'un site internet demeure essentielle pour de nombreuses entreprises et individus. Mais quelle somme devez-vous réellement prévoir pour ce projet ?",
        },
      ],
    };
  },
};
